import { get } from 'lodash'

import { isRequestComplete, isRequestError, isRequestPending, isRequestSuccessful } from '@/store/selectors'

import {
  DEACTIVATE_APP_BUILDER_FEATURE,
  DEPLOY_APP_BUILDER_FEATURE,
  EXECUTE_APP_BUILDER_FEATURE,
  FETCH_APP_BUILDER_DATASOURCE_DOCS,
  FETCH_APP_BUILDER_FEATURE,
  FETCH_APP_BUILDER_FEATURE_EXECUTION,
  FETCH_APP_BUILDER_FEATURE_NO_LOADER,
  FETCH_APP_BUILDER_NOTIFICATION_SOURCES,
  UPDATE_APP_BUILDER_FEATURE
} from './actionTypes'

export const getAppBuilderFeatureData = (state: any) => {
  return {
    feature: get(state, 'SpaceAppBuilderFeaturesPage.feature'),
    execution: get(state, 'SpaceAppBuilderFeaturesPage.execution'),
    isLoading: isRequestPending(state, [FETCH_APP_BUILDER_FEATURE]),
    isLoadingWithNoLoader: isRequestPending(state, [FETCH_APP_BUILDER_FEATURE_NO_LOADER]),
    isSaving: isRequestPending(state, [UPDATE_APP_BUILDER_FEATURE]),
    isExecuting: isRequestPending(state, [EXECUTE_APP_BUILDER_FEATURE]),
    isCompleted: isRequestComplete(state, [FETCH_APP_BUILDER_FEATURE]),
    isExecutionCompleted: isRequestComplete(state, [EXECUTE_APP_BUILDER_FEATURE]),
    isExecutionSuccessful: isRequestSuccessful(state, [EXECUTE_APP_BUILDER_FEATURE]),
    isExecutionError: isRequestError(state, [EXECUTE_APP_BUILDER_FEATURE]),
    isDeploying: isRequestPending(state, [DEPLOY_APP_BUILDER_FEATURE]),
    isDeactivating: isRequestPending(state, [DEACTIVATE_APP_BUILDER_FEATURE])
  }
}
export const getAppBuilderFeatureExecutionData = (state: any) => {
  return {
    buildError: get(state, 'SpaceAppBuilderFeaturesPage.buildError', {}),
    featureExecution: get(state, 'SpaceAppBuilderFeaturesPage.featureExecution', {}),
    isLoading: isRequestPending(state, [FETCH_APP_BUILDER_FEATURE_EXECUTION]),
    isCompleted: isRequestComplete(state, [FETCH_APP_BUILDER_FEATURE_EXECUTION]),
    isError: isRequestError(state, [FETCH_APP_BUILDER_FEATURE_EXECUTION])
  }
}
export const getAppBuilderDataSourcesMappingData = (state: any) => {
  return {
    dataSourcesMapping: get(state, 'SpaceAppBuilderFeaturesPage.dataSourcesMapping'),
    isLoading: isRequestPending(state, [FETCH_APP_BUILDER_DATASOURCE_DOCS]),
    isCompleted: isRequestComplete(state, [FETCH_APP_BUILDER_DATASOURCE_DOCS])
  }
}

export const getAppBuilderNotificationSourcesData = (state: any) => {
  return {
    notificationSources: get(state, 'SpaceAppBuilderFeaturesPage.notificationSources', []),
    isLoading: isRequestPending(state, [FETCH_APP_BUILDER_NOTIFICATION_SOURCES]),
    isComplete: isRequestComplete(state, [FETCH_APP_BUILDER_NOTIFICATION_SOURCES])
  }
}
